<template>
  <transition name="fade">
    <div class="form-error-box alert-div" v-if="errorsCount">
      <b-alert class="form-error" variant="form-error-box" dismissible show fade @dismissed="clearErrors">
        <br>
        <div v-for="(fieldError, fieldIndex) in getValidationErrors" :key="fieldIndex">
          <div v-if="fieldIndex != 'validationName'">
            <div class="error-msg" v-for="error in fieldError" :key="error.key">
              <div v-if="error.key">
                <span style="display: inline-block;">{{ t(error.key, error.key) }}</span><span style="display: inline-block;" v-if="error.value">&nbsp;{{ error.value }}</span>
              </div>
            </div>
          </div>
        </div>
      </b-alert>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'ValidationErrors',
    computed: {
      ...mapGetters(['getValidationErrors']),
      errorsCount() {
        return Object.keys(this.getValidationErrors).length
      }        
    },
    methods: {
      clearErrors() {
        this.$store.dispatch('alertClearErrors')
      }
    }
}
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
      transition: opacity .8s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
  }
  .error-message {
      color: red;
      font-size: 11px;
  }
  .error-msg {
      margin-bottom: 0px;
  }
  .form-error {
      width: 100%;
      word-break: break-all;
  }
  .response-alert-box {
      padding: 0px;
      margin-bottom: 0px;
      position: relative;
  }
  .alert-dismissible .close {
      top: 5px;
      right: 20px !important;
      padding: 0px;
  }
  .alert-dismissible .close {
    color: red;
  }
  .alert-div {
    padding: 0px;
    font-size: 12px;
  }
  .alert-div > div > button {
    padding: 5px 20px 5px 20px;
    border-radius: 0px !important;
  }
  .form-error {
    width: 100%;
    border: 1px solid;
    padding: 10px;
    display: inline-block;
    background-color: rgba(255, 0, 0, 0.1);
    margin-bottom: 0px;
  }
  .form-error-box {
    text-align: center;
    color:red;
    width:100%;
    height: auto;
    border-radius: 5px;
  }
</style>
